import { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface TierPctData {
  high: { pct: number };
  medium: { pct: number };
  low: { pct: number };
}

export function formatPct(pct: number): string {
  return `${pct.toFixed(1)}%`;
}

export function formatNumber(num: number): string {
  return num.toLocaleString();
}

export function formatRange(range: { min: number; max: number }): string {
  return `${range.min}–${range.max}`;
}

export function getCellColor(theme: Theme, cell: TierPctData): string {
  const avgPct = (cell.high.pct + cell.medium.pct + cell.low.pct) / 3;

  if (avgPct >= 40) {
    return alpha(theme.palette.success.main, 0.18);
  }
  if (avgPct >= 25) {
    return alpha(theme.palette.success.main, 0.12);
  }
  if (avgPct >= 15) {
    return alpha(theme.palette.warning.main, 0.18);
  }
  if (avgPct >= 5) {
    return alpha(theme.palette.warning.main, 0.12);
  }
  return alpha(theme.palette.error.main, 0.16);
}

export function getTriangleIconSx(theme: Theme) {
  return {
    width: 0,
    height: 0,
    borderLeft: `${theme.spacing(0.75)} solid transparent`,
    borderRight: `${theme.spacing(0.75)} solid transparent`,
  } as const;
}
